<template>
	<div class="pa-2">
		<div v-for="data in matter_values" :key="data.matter_key.id" class="mt-2">
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						class="mt-4"
						v-if="data.matter_key.date_flag"
						v-model="data.matter_value.value"
						:label="data.matter_key.name"
						required
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
					/>
				</template>

				<v-date-picker
					v-if="data.matter_key.date_flag"
					v-model="data.matter_value.value"
					no-title
					locale="ja-JP"
				/>
			</v-menu>

			<p class="price" v-if="data.matter_key.integer_flag">
				{{ Number(data.matter_value.value).toLocaleString() }}
			</p>

			<v-text-field
				type="number"
				v-if="data.matter_key.integer_flag"
				v-model="data.matter_value.value"
				class="mt-4"
				:label="data.matter_key.name"
				outlined
				dense
			></v-text-field>

			<v-select
				v-if="data.matter_key.boolean_flag"
				v-model="data.matter_value.value"
				class="mt-4"
				outlined
				required
				dense
				:items="booleans"
				item-text="name"
				item-value="value"
			>
			</v-select>

			<v-textarea
				v-if="data.matter_key.text_flag"
				v-model="data.matter_value.value"
				class="mt-4"
				:label="data.matter_key.name"
				outlined
				dense
			></v-textarea>

			<v-text-field
				v-if="data.matter_key.string_flag"
				v-model="data.matter_value.value"
				:label="data.matter_key.name"
				class="mt-4"
				outlined
				dense
			></v-text-field>
		</div>
		<div class="competitor">
			<h2>競合・失注情報</h2>
			<v-text-field
				v-model.trim="detail.competitor"
				label="競合先"
				class="mt-4"
				outlined
				dense
			></v-text-field>
			<v-text-field
				v-if="contract == false && contract !== 'nil'"
				v-model.trim="detail.lostTo"
				label="失注先"
				class="mt-4"
				outlined
				dense
			></v-text-field>
			<v-text-field
				v-if="contract == false && contract !== 'nil'"
				v-model.trim="detail.lostReason"
				label="失注理由"
				class="mt-4"
				outlined
				dense
			></v-text-field>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		matter_values: {
			type: Array,
			required: false,
			default: () => [],
		},
		detail: {
			type: Object,
			required: false,
			default: () => {},
		},
		contract: {
			type: [String, Boolean],
		},
	},
	data() {
		return {}
	},
}
</script>
